/**
 * Author: ligj@mapbar.com
 * Create Time: 2018/01/05 15:09
 * Description:
 */

export const MODAL_PUSH_PAGE = 'MODAL_PUSH_PAGE';
export const MODAL_REMOVE_PAGE = 'MODAL_REMOVE_PAGE';
export const MODAL_UPDATE_PAGE = 'MODAL_UPDATE_PAGE';
export const SET_ROLES = 'SET_ROLES';

export const TAB_VIEW_PUSH = 'TAB_VIEW_PUSH';
export const TAB_VIEW_SHIFT = 'TAB_VIEW_SHIFT';
export const TAB_VIEW_SET_TITLE = 'TAB_VIEW_SET_TITLE';
export const TAB_VIEW_REMOVE = 'TAB_VIEW_REMOVE';
export const TAB_VIEW_ENABLED = 'TAB_VIEW_ENABLED';
export const TAB_VIEW_CLOSE_CURRENT = 'TAB_VIEW_CLOSE_CURRENT';
export const TAB_VIEW_CLOSE_ALL = 'TAB_VIEW_CLOSE_ALL';
export const TAB_VIEW_CLOSE_PAGES = 'TAB_VIEW_CLOSE_PAGES';

export const SET_BREADCRUMB = 'SET_BREADCRUMB';

export const SET_PAGE_ACTIVENAME='SET_PAGE_ACTIVENAME'
export const SET_KEEP_ALIVE = 'SET_KEEP_ALIVE'
export default {
	MODAL_PUSH_PAGE,
    MODAL_REMOVE_PAGE,
    MODAL_UPDATE_PAGE,
    SET_ROLES,
    TAB_VIEW_PUSH,
    TAB_VIEW_SET_TITLE,
    TAB_VIEW_REMOVE,
    TAB_VIEW_ENABLED,
    TAB_VIEW_CLOSE_CURRENT,
    TAB_VIEW_CLOSE_ALL,
    TAB_VIEW_CLOSE_PAGES,
    SET_BREADCRUMB,
    SET_PAGE_ACTIVENAME,
    SET_KEEP_ALIVE
};
